import { Link } from "react-router-dom";
import { ArrowUpRight, ImageIcon } from "lucide-react";
import { MaskLines, Reveal } from "./motion";

export const Container = ({ children, className = "" }) => (
  <div className={`mx-auto max-w-[1400px] px-5 sm:px-8 ${className}`}>{children}</div>
);

export const PageHero = ({ label, lines, intro, testid }) => (
  <section className="spotlight grain relative overflow-hidden pb-16 pt-36 sm:pb-24 sm:pt-44" data-testid={testid}>
    <Container>
      <p className="label">{label}</p>
      <h1 className="mt-6 font-display text-5xl font-semibold leading-[0.95] tracking-tight sm:text-7xl lg:text-8xl">
        <MaskLines lines={lines} delay={0.1} />
      </h1>
      <Reveal delay={0.5}>
        <p className="mt-8 max-w-2xl text-lg leading-relaxed text-[#C8C5BB] sm:text-xl">{intro}</p>
      </Reveal>
    </Container>
  </section>
);

export const SectionHead = ({ label, title, intro, className = "" }) => (
  <Reveal className={`max-w-3xl ${className}`}>
    <p className="label">{label}</p>
    <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.02] sm:text-5xl lg:text-6xl">{title}</h2>
    {intro && <p className="mt-6 text-base leading-relaxed text-[#C8C5BB] sm:text-lg">{intro}</p>}
  </Reveal>
);

export const Placeholder = ({ title, note, className = "", testid }) => (
  <div role="img" aria-label={`Placeholder: ${title}`} data-testid={testid}
    className={`placeholder-box flex flex-col items-center justify-center gap-3 rounded-2xl p-8 text-center ${className}`}>
    <ImageIcon size={28} aria-hidden="true" className="text-[#F3C649]" />
    <p className="label">Placeholder</p>
    <p className="font-display text-2xl text-[#F9F8F6]">{title}</p>
    {note && <p className="max-w-xs text-sm text-[#C8C5BB]">{note}</p>}
  </div>
);

export const CtaBand = ({ title = "Bring JEM to your people.", text = "Tell us about your audience and goals. We'll shape a screening, workshop, keynote, or partnership around them." }) => (
  <section className="relative overflow-hidden border-t border-[#D4AF37]/20 bg-[#07080A] py-24 sm:py-32" data-testid="cta-band">
    <div aria-hidden="true" className="absolute -right-40 top-1/2 h-[520px] w-[520px] -translate-y-1/2 rounded-full bg-[#D4AF37]/10 blur-3xl" />
    <Container className="relative">
      <Reveal>
        <h2 className="max-w-4xl font-display text-5xl font-semibold leading-[0.98] sm:text-6xl lg:text-7xl">{title}</h2>
        <p className="mt-6 max-w-xl text-base text-[#C8C5BB] sm:text-lg">{text}</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/contact" className="btn-gold" data-testid="cta-band-partner-btn">Discuss a JEM Partnership <ArrowUpRight size={18} aria-hidden="true" /></Link>
          <Link to="/program" className="btn-ghost" data-testid="cta-band-program-btn">Explore the Program</Link>
        </div>
      </Reveal>
    </Container>
  </section>
);
